
export default {
  name: 'test',
  data () {
    return {
      arr: [
        { ID: 1000, COUNT: 1 },
        { ID: 1001, COUNT: 1 },
        { ID: 1002, COUNT: 1 },
        { ID: 1003, COUNT: 1 },
        { ID: 1004, COUNT: 1 }
      ],
      testDate: '',
      Count: 1,
      isAdd: false

    }
  },
  components: {
  },
  created () {

  },
  methods: {
    btnAdd () {
      this.Count++
    },
    btnMinus () {
      this.Count--
    },
    isNull () {
      if (this.Count === 0) {
        this.Count = 1
      } else {
        this.Count = Math.ceil(this.Count)
      }
    },
    isBlur () {
      // console.log('isBlur:  ' + this.Count)
      if (this.Count === 0) {
        this.Count = 1
      }
    },
    async addArr  () {
      if (this.testDate.length >= 4) {
        console.log('通过')
        const newObj = { ID: this.testDate, COUNT: this.Count }
        for (let i = 0; i < this.arr.length; i++) {
          if (parseInt(newObj.ID) === parseInt(this.arr[i].ID)) {
            await console.log('找到了重复的数组！位置在' + i + '行')
            this.arr[i].COUNT = this.arr[i].COUNT + parseInt(newObj.COUNT)
            this.isAdd = false
            break
          } else {
            if (i === this.arr.length - 1) {
              console.log('到底啦！')
              this.isAdd = true
            }
          }
        }
        if (this.isAdd === true) {
          await this.arr.push(newObj)
          this.isAdd = false
        }
      } else {
        console.log('不行！')
      }
    }

  }
}
